import React from 'react';
import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords, image }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name='description' content={description} />
            <meta name='keyword' content={keywords} />
            <link rel="canonical" href={`https://fruvalleykashmir.in${window.location.pathname}`} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={`https://fruvalleykashmir.in${window.location.pathname}`} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

Meta.defaultProps = {
    title: 'FruValley Store - Authentic Kashmir',
    description: 'FruValley: Empowering Kashmir\'s trade and new businesses. Connect, trade, and grow with FruValley. Discover authentic locations and stories of Kashmir.',
    keywords: 'FruValley Online Store, Buy Kashmiri Dry Fruits, Saffron, Walnuts, Kashmir Shopping, FruValley Business, Organic Market, Authentic Kashmir Products, Online Grocery Kashmir',
    image: 'https://fruvalleykashmir.in/logo512.png',
};

export default Meta;
